import { ListItemButton, ListItemText, Popover } from "@mui/material";
import React, { useEffect, useState } from "react";
import { StyledList } from "./BasketPageDotMenu.style";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import { BasketUploadPopup } from "./upload/BasketUploadPopup";
import { useExcelUtility } from "../../../explorer/utils/ExcelUtils";
import { BasketItem } from "../../../explorer/types/Basket/BasketItems";
import { useBasket } from "../../hook/useBasket";
import useRefresh from "../../hook/useRefresh";
import { useLocation } from "react-router";

import { useNavigate } from "react-router-dom";
import { useApiError } from "../../hook/useApiError";
import CommonDialog from "../CommonDialog/CommonDialog";
import BasketTransferDialog from "./BasketTransferDialog";

export const BasketPageDotsMenu: React.FC<{
    onClose?: any;
    anchorElement: HTMLButtonElement | null;
    onClearBasket: any;
    onPrintBasket: any;
    onTransferBasket: any;
    basketItems: BasketItem[];
    reloadPrice: any;
}> = ({
    anchorElement,
    onClose,
    onClearBasket,
    onPrintBasket,
    onTransferBasket,
    basketItems,
    reloadPrice,
}) => {
    /*const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };*/

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
        anchorElement
    );

    useEffect(() => {
        setAnchorEl(anchorElement);
    }, [anchorElement]);

    const open = Boolean(anchorEl);
    const id = open ? "basketlist-actions" : undefined;

    const [error, setError] = useApiError();

    const navigate = useNavigate();

    const location = useLocation();

    const refresh = useRefresh(navigate);

    const [clearDialogOpen, setClearDialogOpen] = useState<boolean>(false);
    const [transferDialogOpen, setTransferDialogOpen] =
        useState<boolean>(false);

    const { t } = useTranslation();

    //#########################################################
    //###################   BASKET UPLOAD   ###################
    //#########################################################

    const [uploadBasketPopupVisible, setUploadBasketPopupVisible] =
        useState(false);

    const handleBasketUpload = () => {
        reloadPrice();
        //refresh(location.pathname);
    };

    //#########################################################
    //###################   BASKET EXPORT   ###################
    //#########################################################
    const excelUtility = useExcelUtility();
    const basketHook = useBasket();
    // const [currentBasket, setCurrentBasket] = useReduxState<Basket>(
    //     reduxStoreConfig.basketCurrentBasket
    // );
    const currentBasket = basketHook.currentBasket;

    const handleExportBasket = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
        if (onClose) onClose();

        if (
            basketItems === null ||
            (basketItems !== null && basketItems.length === 0)
        ) {
            setError(t("basket.isEmpty"));
            return;
        }

        const dataBasketToExport: Array<Record<string, any>> = [];
        basketItems.map((_row) => {
            dataBasketToExport.push({
                [t("common.spareparts.part.code")]: _row.code,
                [t("common.spareparts.part.qty")]: _row.qty,
                [t("common.spareparts.part.mcc")]: _row.manufacturerCompanyCode,
                [t("common.spareparts.part.description")]: _row.partDescription,
                [t("common.spareparts.part.uom")]: _row.uom ?? "PCE",
            });
        });

        excelUtility.exportToExcelJson(dataBasketToExport, currentBasket.name!);
    };

    const handleClose = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
        if (onClose) onClose();
    };

    const handleImportBasket = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
        setUploadBasketPopupVisible(true);
        if (onClose) onClose();
    };

    const handleClearBasket = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
        if (onClose) onClose();
        setClearDialogOpen(true);
    };

    const handlePrintBasket = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
        if (onClose) onClose();
        onPrintBasket();
    };

    const handleTransferBasket = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
        if (onClose) onClose();
        setTransferDialogOpen(true);
        // ServiceProvider.Basket.get
    };

    const handleCloseClearDialog = () => {
        setClearDialogOpen(false);
    };

    const handleClearDialog = () => {
        onClearBasket();
        handleCloseClearDialog();
    };

    const handleCloseTransferDialog = () => {
        setTransferDialogOpen(false);
    };

    const handleTransferDialog = (username: string) => {
        onTransferBasket(username);
        handleCloseTransferDialog();
    };

    return (
        <>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "center",
                    horizontal: "right",
                }}
                style={{ zIndex: 1000000 }}
                //classes={{ paper: partDetailClass.availabilityPopoverPaper }}
            >
                <StyledList aria-label="">
                    <ListItemButton
                        onClick={(_e) => {
                            handleImportBasket(_e);
                        }}
                    >
                        <ListItemText
                            primary={
                                t("common.spareparts.basket.upload") as string
                            }
                        />
                    </ListItemButton>
                    <ListItemButton
                        onClick={(_e) => {
                            handleExportBasket(_e);
                        }}
                    >
                        <ListItemText
                            primary={
                                t("common.spareparts.basket.export") as string
                            }
                            onClick={(_e) => {
                                handleExportBasket(_e);
                            }}
                        />
                    </ListItemButton>
                    <ListItemButton onClick={handlePrintBasket}>
                        <ListItemText
                            primary={
                                t("common.spareparts.basket.print") as string
                            }
                        />
                    </ListItemButton>
                    <ListItemButton onClick={handleClearBasket}>
                        <ListItemText
                            primary={
                                t("common.spareparts.basket.empty") as string
                            }
                        />
                    </ListItemButton>
                    <ListItemButton onClick={handleTransferBasket}>
                        <ListItemText
                            primary={
                                t("common.spareparts.basket.transfer") as string
                            }
                        />
                    </ListItemButton>
                </StyledList>
            </Popover>
            <BasketUploadPopup
                open={uploadBasketPopupVisible}
                onClose={(val: boolean) => {
                    setUploadBasketPopupVisible(val);
                }}
                reloadPrice={handleBasketUpload}
            />
            <CommonDialog
                open={clearDialogOpen}
                dialogTitleLabel={"common.basket.confirmDeleteTitle"}
                dialogContentLabel={"common.basket.confirmClear"}
                closeDialog={handleCloseClearDialog}
                confirmButton={handleClearDialog}
            />
            <BasketTransferDialog
                open={transferDialogOpen}
                handleCloseTransferDialog={handleCloseTransferDialog}
                handleTransferDialog={handleTransferDialog}
            />
        </>
    );
};
